import React, { useState, useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import {
  GraphQLData,
  GraphQLEdge,
  BlogPostFrontmatter,
  DividedBlogRoll,
} from "@wp/ui"

const Posts: React.FC<{ perPagnition?: number }> = ({ perPagnition = 8 }) => {
  const data: GraphQLData = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
      ) {
        edges {
          node {
            excerpt(pruneLength: 400)
            id
            fields {
              slug
            }
            frontmatter {
              title
              templateKey
              date(formatString: "MMMM DD, YYYY")
              featuredpost
              description
              image {
                childImageSharp {
                  fluid(maxWidth: 1200, quality: 30) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              imageCredit
            }
          }
        }
      }
    }
  `)
  const { edges } = data.allMarkdownRemark

  const [posts, setPosts] = useState<GraphQLEdge<BlogPostFrontmatter>[]>([])
  const [pagnition, setPagnition] = useState<number>(perPagnition)

  useEffect(() => {
    setPosts(edges.slice(0, 1 * pagnition))
  }, [edges, pagnition])
  return (
    <DividedBlogRoll
      id="posts"
      title="All Posts"
      posts={posts}
      showLoadMoreButton={posts.length < edges.length}
      onLoadMore={(): void => {
        setPagnition((prevState) => prevState + 1)
      }}
    />
  )
}
export default Posts
